import { useMutation, useQueryClient } from '@tanstack/react-query';
import { appApiAiCenter } from 'configs/variables';
import useHttpClient from 'hooks/useHttpClient';
import { suspectKeys } from '../keys';

// DELETE /api/suspects/{suspect_id}
export function useDeleteSuspect({ id = '', onSuccess = undefined, onError = undefined } = {}) {
  const { deletes } = useHttpClient();
  const queryClient = useQueryClient();

  const queryMutation = useMutation({
    mutationKey: suspectKeys.delete.queryKey,
    mutationFn: async () =>
      await deletes({
        url: appApiAiCenter + '/suspects/' + id,
      }),
    onSuccess: (...args) => {
      queryClient.invalidateQueries({
        queryKey: suspectKeys.all._def,
      });

      if (onSuccess) {
        onSuccess(...args);
      }
    },
    onError: (error, ...args) => {
      if (onError) {
        if (!error) return;
        onError(error, ...args);
      }
    },
  });

  return queryMutation;
}
